import React, { useEffect, useState } from 'react'
import { Autocomplete } from '@pcln/horizon'
import useTypeAhead from '@/components/TypeAhead/useTypeAhead'
import type { LOCATION_SEARCH_TYPE } from '@/types'

export default function AutocompleteWrapper({
  searchKey
}: {
  searchKey: string
}) {
  const [autocompleteValue, setAutocompleteValue] = useState<string | null>(
    null
  )

  const [autocompleteData, setAutocompleteData] = useState<
    LOCATION_SEARCH_TYPE[]
  >([])

  const typeAheadHorizon = useTypeAhead({
    searchValue: autocompleteValue,
    searchKey,
    onLoaded: () => null,
    debounceTime: 100,
    typeAheadEndpoint: 'hotels'
  })

  useEffect(() => {
    setAutocompleteData(typeAheadHorizon.items)
  }, [autocompleteValue, typeAheadHorizon])

  return (
    <Autocomplete
      autocompleteData={autocompleteData}
      handleInputChange={(inputValue: string) => {
        setAutocompleteValue(inputValue)
      }}
    />
  )
}
